export class ApprovalType {
  ID: number;
  Name: string;
}

export default ApprovalType;
